export enum ModalType {
  Secondary,
  Success,
  Danger
}

export type BadgeType = 'actief' | 'test' | 'verwijderd' | 'inactief' | 'info' | undefined;

export enum Colors {
  Primary = 'primary',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info'
}
